module.exports = __webpack_public_path__ + "static/media/module3.eee5c717.png";